/**
 * Team Redux Actions
 * Actions for managing team members and requests data
 */

// ── Members Action Types ──
export const TEAM_MEMBERS_REQUEST = 'team/MEMBERS_REQUEST';
export const TEAM_MEMBERS_SUCCESS = 'team/MEMBERS_SUCCESS';
export const TEAM_MEMBERS_ERROR = 'team/MEMBERS_ERROR';
export const TEAM_MEMBERS_RESET = 'team/MEMBERS_RESET';
export const TEAM_MEMBERS_SET_PARAMS = 'team/MEMBERS_SET_PARAMS';

// ── Requests (Invitations) Action Types ──
export const TEAM_REQUESTS_REQUEST = 'team/REQUESTS_REQUEST';
export const TEAM_REQUESTS_SUCCESS = 'team/REQUESTS_SUCCESS';
export const TEAM_REQUESTS_ERROR = 'team/REQUESTS_ERROR';
export const TEAM_REQUESTS_RESET = 'team/REQUESTS_RESET';
export const TEAM_REQUESTS_SET_PARAMS = 'team/REQUESTS_SET_PARAMS';

// Action Creators

/**
 * Request action for fetching team members
 * @returns {Object} Action object
 */
export const getTeamMembersRequest = () => ({
    type: TEAM_MEMBERS_REQUEST,
});

/**
 * Success action for fetching team members
 * @param {Object} payload
 * @param {Array} payload.data - Array of user/invite objects (mixed via is_prospect flag)
 * @param {Object} payload.pagination - { offset, limit, count }
 * @returns {Object} Action object
 */
export const getTeamMembersSuccess = ({ data, pagination }) => ({
    type: TEAM_MEMBERS_SUCCESS,
    payload: { data, pagination },
});

/**
 * Error action for fetching team members
 * @param {string} error - Error message
 * @returns {Object} Action object
 */
export const getTeamMembersError = (error) => ({
    type: TEAM_MEMBERS_ERROR,
    payload: error,
});

/**
 * Reset action for clearing team members state
 * @returns {Object} Action object
 */
export const resetTeamMembers = () => ({
    type: TEAM_MEMBERS_RESET,
});

/**
 * Update the stored query params (search, sort, filter, page) without triggering a fetch
 * @param {Object} params - Updated query params
 * @returns {Object} Action object
 */
export const setTeamMembersParams = (params) => ({
    type: TEAM_MEMBERS_SET_PARAMS,
    payload: params,
});

// ── Requests (Invitations) Action Creators ──

/**
 * Request action for fetching team requests
 * @returns {Object} Action object
 */
export const getTeamRequestsRequest = () => ({
    type: TEAM_REQUESTS_REQUEST,
});

/**
 * Success action for fetching team requests
 * @param {Object} payload
 * @param {Array} payload.data - Array of invitation objects
 * @param {Object} payload.pagination - { offset, limit, count }
 * @returns {Object} Action object
 */
export const getTeamRequestsSuccess = ({ data, pagination }) => ({
    type: TEAM_REQUESTS_SUCCESS,
    payload: { data, pagination },
});

/**
 * Error action for fetching team requests
 * @param {string} error - Error message
 * @returns {Object} Action object
 */
export const getTeamRequestsError = (error) => ({
    type: TEAM_REQUESTS_ERROR,
    payload: error,
});

/**
 * Reset action for clearing team requests state
 * @returns {Object} Action object
 */
export const resetTeamRequests = () => ({
    type: TEAM_REQUESTS_RESET,
});

/**
 * Update the stored query params for requests without triggering a fetch
 * @param {Object} params - Updated query params
 * @returns {Object} Action object
 */
export const setTeamRequestsParams = (params) => ({
    type: TEAM_REQUESTS_SET_PARAMS,
    payload: params,
});
